export default "__VITE_ASSET__BpCDQg0i__"